// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
import 'whatwg-fetch'

import EdkClient from './client'
import EdkHost from './host'

export const Host = EdkHost
export const Client = EdkClient
